import React from 'react';
import * as PropTypes from 'prop-types';
import { get } from 'lodash';
import Warning from 'components/Warning';
import Loading from 'components/Loading';
import config from 'config';

import styles from './CaptchaGoogle.module.scss';

export function CaptchaGoogle({ verifyCallback, expiredCallback }) {
  const containerRef = React.useRef();
  const [isLoading, setIsLoading] = React.useState(true);
  const [isError, setIsError] = React.useState(false);

  async function onloadCallback() {
    try {
      await window.grecaptcha.render(containerRef.current, {
        sitekey: config.recaptchaApiKey,
        callback: verifyCallback,
        'expired-callback': expiredCallback,
      });
    } catch {
      onErrorCallback();
    }

    const iframe = containerRef.current && containerRef.current.querySelector('iframe');
    if (iframe) {
      iframe.onload = function () {
        setIsLoading(false);
      };
      iframe.onerror = function () {
        onErrorCallback();
      };
    }
  }

  function onErrorCallback() {
    setIsError(true);
    setIsLoading(false);
  }

  React.useEffect(() => {
    if (get(window, 'grecaptcha.isLoaded')) {
      onloadCallback();
    } else if (get(window, 'grecaptcha.isError')) {
      onErrorCallback();
    } else {
      window.addEventListener('reCaptchaLoaded', onloadCallback);
      window.addEventListener('reCaptchaError', onErrorCallback);
    }
    return () => {
      window.removeEventListener('reCaptchaLoaded', onloadCallback);
      window.removeEventListener('reCaptchaError', onErrorCallback);
    };
  }, []);
  return (
    <div className={styles.captchaContainer}>
      {isLoading && <Loading />}
      <div ref={containerRef} />
      {isError && <Warning />}
    </div>
  );
}

CaptchaGoogle.propTypes = {
  verifyCallback: PropTypes.func.isRequired,
  expiredCallback: PropTypes.func.isRequired,
};

export function resetCaptcha() {
  window.grecaptcha.reset();
}
